import React, { FunctionComponent } from "react";
import { localizationDefaults } from "src/utils";
import { isUS } from "src/utils/account";
import { AccountState } from "Types/state";
import CaTermsAndPrivacy from "./CaTermsAndPrivacy";
import UsTermsAndPrivacy from "./UsTermsAndPrivacy";

interface Props {
    account: AccountState;
    optInMarketing?: boolean;
    optInTransactional?: boolean;
    region?: string;
    onAgreeTransactionalClick?: (answer: boolean) => void;
    onAgreePromotionalClick?: (answer: boolean) => void;
}

const TermsAndPrivacy: FunctionComponent<Props> = (props) => {
    return isUS(props.region) ? (
        <UsTermsAndPrivacy account={props.account} />
    ) : (
        <CaTermsAndPrivacy
            account={props.account}
            optInMarketing={props.optInMarketing || false}
            optInTransactional={props.optInTransactional || false}
            onAgreeTransactionalClick={props.onAgreeTransactionalClick}
            onAgreePromotionalClick={props.onAgreePromotionalClick}
        />
    );
};

TermsAndPrivacy.defaultProps = {
    region: localizationDefaults.country,
};

export default TermsAndPrivacy;
